import { motion } from "framer-motion";
import { Heart, MessageCircle, Play, Layers } from "lucide-react";
import { compact, proxied, timeAgo } from "@/lib/feed";
import { TrendingBadge } from "@/components/feed/TrendingBadge";

const KindIcon = ({ kind }) => {
  if (kind === "video") return <Play className="h-4 w-4 fill-current" />;
  if (kind === "carousel") return <Layers className="h-4 w-4" />;
  return null;
};

const WIDE = { 2: "md:col-span-2 md:aspect-[2/1]", 3: "md:col-span-3 md:aspect-[3/1]", 4: "md:col-span-4 md:aspect-[4/1]" };

export const PostCard = ({ post, index, featured, trending, span = 1, onOpen }) => (
  <motion.button
    type="button"
    onClick={onOpen}
    data-testid={`post-card-${post.shortcode}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay: (index % 4) * 0.08 }}
    className={`group relative block w-full text-left overflow-hidden cursor-zoom-in bg-[var(--ink-2)] ${featured ? "md:col-span-2 md:row-span-2" : ""} ${WIDE[span] || ""}`}
  >
    <div className={`aspect-square w-full h-full ${span > 1 ? "md:absolute md:inset-0 md:aspect-auto" : ""}`}>
      <img
        src={proxied(post.image_url)}
        alt={post.caption.slice(0, 80) || "Instagram post"}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100"
      />
    </div>
    <div className="absolute top-4 right-4 text-[var(--bone)] drop-shadow"><KindIcon kind={post.kind} /></div>
    {trending && <TrendingBadge testid={`trending-badge-${post.shortcode}`} className="absolute top-3 left-3" />}
    <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/90 via-black/30 to-transparent p-5 md:p-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
      <p className={`text-[var(--bone)] leading-snug ${featured ? "font-display text-xl md:text-2xl line-clamp-4" : "text-sm line-clamp-3"}`}>
        {post.caption || "View on Instagram"}
      </p>
      <div className="mt-4 flex items-center gap-4 font-mono text-[11px] text-[var(--ash)]">
        <span className="flex items-center gap-1"><Heart className="h-3 w-3" />{compact(post.likes)}</span>
        <span className="flex items-center gap-1"><MessageCircle className="h-3 w-3" />{compact(post.comments)}</span>
        <span className="ml-auto uppercase tracking-widest">{timeAgo(post.posted_at)}</span>
      </div>
    </div>
  </motion.button>
);
